import React from 'react';
import {Autocomplete, TextField} from '@mui/material';

const estados = [
  {id:1, descripcion:'Observado'},
  {id:2, descripcion:'Derivado'},
  {id:3, descripcion:'Parcial'},
  {id:4, descripcion:'Finalizado'}
]

export default class Pase extends React.Component{
  constructor(props){
    super(props);
    this.state={}
  }

  render(){
    const {areaSelec,estadoSelec, observaciones} = this.props.datos;
    const {nuevo, areas, editar} = this.props 
    return(
      <div style={{width:'100%', borderRadius:10, backgroundColor:'white', padding:10, margin:10, display:'flex', flexDirection:'column'}}>
        <h3 style={{textAlign:'center'}}>Realizar pase</h3>
        <div style={{display:'flex', flexDirection:'row', width:'100%'}}>
          {!nuevo && 
            <Autocomplete
              value={estadoSelec}
              onChange={(e,n) => editar('estadoSelec',n)}
              isOptionEqualToValue={(option, value) => option.id === value.id }
              options={estados}
              getOptionLabel={(option) => option.descripcion}
              size="small"
              disableClearable
              style={{margin:'5px 1px',flex:2, fontSize:5}}
              fontSize="small"
              renderInput={(params) => <TextField {...params} label="Estado"/>}
            />
          }
          <Autocomplete
            value={areaSelec}
            onChange={(e,n) => editar('areaSelec',n)}
            isOptionEqualToValue={(option, value) => option.id === value.id }
            options={!nuevo ? estadoSelec?.id !== 1 ? areas : areas.filter((item) => item.mesa) : areas}
            getOptionLabel={(option) => option.nombre}
            size="small"
            disableClearable
            disabled={estadoSelec?.id === 1 || estadoSelec?.id === 3 || estadoSelec?.id === 4}
            style={{margin:'5px 1px',flex:2, fontSize:5}}
            fontSize="small"
            renderInput={(params) => <TextField {...params} label="Área"/>}
          />
        </div>
        <div style={{display:'flex', flexDirection:'row', width:'100%'}}>
          <TextField
            size="small"
            style={{flex:1,textAlign:'center',minWidth:0,margin:'5px 1px'}}
            label="Observaciones"
            value={observaciones}
            onChange={(e) => editar('observaciones',e.target.value)}
            variant="outlined"
            multiline
            rows={4}
          />
        </div>
      </div>
    )
  }
}